import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function TestPreCheck() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [cameraOk, setCameraOk] = useState(false);
  const [screenOk, setScreenOk] = useState(false);
  const [networkOk, setNetworkOk] = useState(false);
  const [warning, setWarning] = useState("");

  const checkCamera = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraOk(true);
      setWarning("");
    } catch {
      setWarning("Camera access is mandatory");
    }
  };

  const checkScreen = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { displaySurface: "monitor" },
      });

      const track = stream.getVideoTracks()[0];
      if (track.getSettings().displaySurface !== "monitor") {
        setWarning("Please share ENTIRE SCREEN only");
        setScreenOk(false);
      } else {
        setScreenOk(true);
        setWarning("");
      }
    } catch {
      setWarning("Screen sharing required");
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      setNetworkOk(true);
    } else {
      setWarning("No internet connection");
    }
  }, []);

  const allGood = cameraOk && screenOk && networkOk;

  return (
    <div className="min-h-screen bg-gray-950 text-white px-8 py-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">
          Pre-Test Verification
        </h1>
        <p className="text-gray-400 mb-8">
          Complete all checks before starting the test
        </p>

        {warning && (
          <div className="bg-red-900/40 border border-red-600
          text-red-300 p-4 rounded-lg mb-6">
            ⚠️ {warning}
          </div>
        )}

        <div className="space-y-5">
          {/* CAMERA */}
          <div className="bg-gray-900 border border-gray-800
          p-5 rounded-xl flex justify-between items-center">
            <div>
              <p className="font-semibold">Camera Access</p>
              <p className="text-sm text-gray-400">
                Required for proctoring
              </p>
            </div>
            <button
              onClick={checkCamera}
              className={`px-4 py-2 rounded-lg font-semibold ${
                cameraOk
                  ? "bg-green-600"
                  : "bg-gray-700 hover:bg-gray-600"
              }`}
            >
              {cameraOk ? "Verified ✅" : "Verify"}
            </button>
          </div>

          {/* SCREEN */}
          <div className="bg-gray-900 border border-gray-800
          p-5 rounded-xl flex justify-between items-center">
            <div>
              <p className="font-semibold">Screen Sharing</p>
              <p className="text-sm text-gray-400">
                Entire screen only
              </p>
            </div>
            <button
              onClick={checkScreen}
              className={`px-4 py-2 rounded-lg font-semibold ${
                screenOk
                  ? "bg-green-600"
                  : "bg-gray-700 hover:bg-gray-600"
              }`}
            >
              {screenOk ? "Shared ✅" : "Share Screen"}
            </button>
          </div>

          {/* NETWORK */}
          <div className="bg-gray-900 border border-gray-800
          p-5 rounded-xl flex justify-between items-center">
            <div>
              <p className="font-semibold">Internet Connection</p>
              <p className="text-sm text-gray-400">
                Stable connection required
              </p>
            </div>
            <span
              className={`px-4 py-2 rounded-lg font-semibold ${
                networkOk
                  ? "bg-green-600"
                  : "bg-gray-700"
              }`}
            >
              {networkOk ? "Connected ✅" : "Checking..."}
            </span>
          </div>
        </div>

        <button
          disabled={!allGood}
          onClick={() => navigate(`/tests/${id}/attempt`)}
          className={`w-full mt-10 py-4 rounded-xl text-lg font-bold ${
            allGood
              ? "bg-blue-600 hover:bg-blue-700"
              : "bg-gray-700 opacity-50 cursor-not-allowed"
          }`}
        >
          Start Test
        </button>
      </div>
    </div>
  );
} 
